<div class="argo-ids__content" *ngIf="argoIds && argoIds.length > 0">
  <div class="argo-ids__content-main"></div>
  <aside class="argo-ids__content-aside" #argoIdsContainer>
    <div class="argo-ids__title" i18n>Argo saved</div>
    <lx-button class="argo-ids__id" [block]="true" (buttonClick)="copyArgoId(i)" *ngFor="let argoId of argoIds; let i = index" i18n>
      Copy {{ argoId }}</lx-button
    >
  </aside>
</div>
